import { render, staticRenderFns } from "./christmasSpinWin.vue?vue&type=template&id=dea083da&scoped=true&"
import script from "./christmasSpinWin.vue?vue&type=script&lang=js&"
export * from "./christmasSpinWin.vue?vue&type=script&lang=js&"
import style0 from "./christmasSpinWin.vue?vue&type=style&index=0&id=dea083da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea083da",
  null
  
)

export default component.exports